import { Stack, Typography, useTheme } from "@mui/material";
import SubscriptionIcon from "src/components/ui/svgIcon/SubscriptionIcon";

const TrackingCard = (props) => {
  const theme = useTheme();
  const { name, icon } = props;

  return (
    <Stack
      sx={{
        borderRadius: (theme) => `${theme.shape.borderRadius * 1.5}px`,
        ...(name === "مجله" || name === "کیف پول" || name === "تنظیمات"
          ? {
              backgroundColor: (theme) => `${theme.palette.grey.g4}`,
            }
          : {
              backgroundColor: (theme) => `${theme.palette.grey.gb}`,
            }),

        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        userSelect: "none",
        cursor: "pointer",
        px: 0.5,
        py: 1.5,

        "&:hover": {
          backgroundColor: theme.palette.primary.main,
        },
      }}
      width="100%"
      height="100%"
    >
      {icon || <SubscriptionIcon />}
      <Typography mt={1} variant="caption" textAlign="center" fontWeight="fontWeightMedium">
        {name}
      </Typography>
    </Stack>
  );
};

export default TrackingCard;
